import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { ProductoModalComponent } from './producto-modal/producto-modal.component';
// import { ServicioModalComponent } from './servicio-modal/servicio-modal.component';
// import { ProveedorModalComponent } from './proveedor-modal/proveedor-modal.component';
// import { BlockModalComponent } from './block-modal/block-modal.component';
// import { ClienteModalComponent } from './cliente-modal/cliente-modal.component';
// import { ClienteProformaModalComponent } from './cliente-proforma-modal/cliente-proforma-modal.component';
// import { ProductoPrecioModalComponent } from './producto-precio-modal/producto-precio-modal.component';
// import { VentaModalComponent } from './venta-modal/venta-modal.component';
// import { VentaFilterModalComponent } from './venta-filter-modal/venta-filter-modal.component';
// import { CompraModalComponent } from './compra-modal/compra-modal.component';
// import { CompraFilterModalComponent } from './compra-filter-modal/compra-filter-modal.component';
// import { VentaListModalComponent } from './venta-list-modal/venta-list-modal.component';
// import { RetencionModalComponent } from './retencion-modal/retencion-modal.component';
// import { RetencionCompraModalComponent } from './retencion-compra-modal/retencion-compra-modal.component';
// import { CompraListModalComponent } from './compra-list-modal/compra-list-modal.component';
// import { PermisoModalComponent } from './permiso-modal/permiso-modal.component';
// import { ImageModalComponent } from './image-modal/image-modal.component';
// import { AperturaCajaModalComponent } from './apertura-caja-modal/apertura-caja-modal.component';
// import { CierreCajaModalComponent } from './cierre-caja-modal/cierre-caja-modal.component';
// import { PrecioAdicionalModalComponent } from './precio-adicional-modal/precio-adicional-modal.component';
// import { ReposicionCajaModalComponent } from './reposicion-caja-modal/reposicion-caja-modal.component';
// import { UsuarioModalComponent } from './usuario-modal/usuario-modal.component';
// import { CajaModalComponent } from './caja-modal/caja-modal.component';
// import { ReporteModalComponent } from './reporte-modal/reporte-modal.component';
// import { FacturaModalComponent } from './factura-modal/factura-modal.component';
// import { ProformaModalComponent } from './proforma-modal/proforma-modal.component';
// import { GuiaremisionModalComponent } from './guiaremision-modal/guiaremision-modal.component';
// import { AjusteInventarioModalComponent } from './ajuste-inventario-modal/ajuste-inventario-modal.component';
// import { ReenviarCorreoComponent } from './reenviar-correo/reenviar-correo.component';
// import { TransferenciasModalComponent } from './transferencias-modal/transferencias-modal.component';
// import { TransferenciasListModalComponent } from './transferencias-list-modal/transferencias-list-modal.component';
// import { NotacreditoModalComponent } from './notacredito-modal/notacredito-modal.component';
// import { NotacreditoCompraModalComponent } from './nota-credito-compra-modal/notacredito-compra-modal.component';
// import { NotadebitoModalComponent } from './notadebito-modal/notadebito-modal.component';
// import { ConfirmacionAnulacionModalComponent } from './confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
// import { EditarPrecioModalComponent } from './editar-precio-modal/editar-precio-modal.component';
// import { GastoModalComponent } from './gasto-modal/gasto-modal.component';
// import { PreciosModalComponent } from './precios-modal/precios-modal.component';
// import { PlanAcumulativoModalComponent } from './plan-acumulativo-modal/plan-acumulativo-modal.component';
// import { EmitirRetencionCompraModalComponent } from './emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
// import { EmitirGuiaremisionVentaModalComponent } from './emitir-guiaremision-venta-modal/emitir-guiaremision-venta-modal.component';
// import { RetencionRentaModalComponent } from './retencion-renta-modal/retencion-renta-modal.component';
// import { LoteModalComponent } from './lote-modal/lote-modal.component';
import { LoadingModule } from 'ngx-loading';
import { PipesModule } from '../../pipes/pipes.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ControlsModule } from '../../controls/controls.module';
import { CustomFormModule } from '../../forms/custom-form.module';
import { PrecioEditModalComponent } from './precio-edit-modal/precio-edit-modal.component';
import { TextMaskModule } from 'angular2-text-mask';
// import { SerieIngresoModalComponent } from './serie-ingreso-modal/serie-ingreso-modal.component';

// import { ConciliacionModalComponent } from './conciliacion-modal/conciliacion-modal.component';
// import { MovimientoBancarioModalComponent } from './movimiento-bancario-modal/movimiento-bancario-modal.component';
// import { CuentaBancariaModalComponent } from './cuenta-bancaria-modal/cuenta-bancaria-modal.component';
// import { HabitacionEditModalComponent } from './habitacion-edit-modal/habitacion-edit-modal.component';
// import { HabitacionAddModalComponent } from './habitacion-add-modal/habitacion-add-modal.component';
// import { TipoHabitacionHotelEditModalComponent } from './tipo-habitacion-hotel-edit-modal/tipo-habitacion-hotel-edit-modal.component';
// import { NivelHotelEditModalComponent } from './nivel-hotel-edit-modal/nivel-hotel-edit-modal.component';
// import { ActivoFijoModalComponent } from './activo-fijo-modal/activo-fijo-modal.component';
// import { TransportistaModalComponent } from './transportista-modal/transportista-modal.component';
// import { CompraNotaModalComponent } from './compra-nota-modal/compra-nota-modal.component';
// import { LectorBarraModalComponent } from './lector-barra-modal/lector-barra-modal.component';
// import { VentaNotaModalComponent } from './venta-nota-modal/venta-nota-modal.component';
// import { OrdenCompraModalComponent } from './orden-compra-modal/orden-compra-modal.component';
// import { OrdenCompraAddModalComponent } from './orden-compra-add-modal/orden-compra-add-modal.component';
// import { PlanCuentasAddModalComponent } from './plan-cuentas-add-modal/plan-cuentas-add-modal.component';
// import { PlanCuentasEditModalComponent } from './plan-cuentas-edit-modal/plan-cuentas-edit-modal.component';
// import { PeriodoAddModalComponent } from './periodo-add-modal/periodo-add-modal.component';
// import { SalaMesaModalComponent } from './sala-mesa-modal/sala-mesa-modal.component';
// import { FacturarPedidoModalComponent } from './facturar-pedido-modal/facturar-pedido-modal.component';
// import { CuentaContableModalComponent } from './cuenta-contable-modal/cuenta-contable-modal.component';
// import { AsientoContableModalComponent } from './asiento-contable-modal/asiento-contable-modal.component';
// import { TransportistaModalComponent } from './transportista-modal/transportista-modal.component';
// import { CompraNotaModalComponent } from './compra-nota-modal/compra-nota-modal.component';
// import { LectorBarraModalComponent } from './lector-barra-modal/lector-barra-modal.component';
// import { VentaNotaModalComponent } from './venta-nota-modal/venta-nota-modal.component';
// import { OrdenCompraModalComponent } from './orden-compra-modal/orden-compra-modal.component';
// import { OrdenCompraAddModalComponent } from './orden-compra-add-modal/orden-compra-add-modal.component';
// import { PlanCuentasAddModalComponent } from './plan-cuentas-add-modal/plan-cuentas-add-modal.component';
// import { PlanCuentasEditModalComponent } from './plan-cuentas-edit-modal/plan-cuentas-edit-modal.component';
// import { PeriodoAddModalComponent } from './periodo-add-modal/periodo-add-modal.component';
// import { SalaMesaModalComponent } from './sala-mesa-modal/sala-mesa-modal.component';
// import { FacturarPedidoModalComponent } from './facturar-pedido-modal/facturar-pedido-modal.component';
// import { PedidosSinSalaComponent } from './pedidos-sin-sala/pedidos-sin-sala.component';
// import { IceModalComponent } from './ice-modal/ice-modal.component';
// import { CuentaContableBancoModalComponent } from './cuenta-contable-banco-modal/cuenta-contable-banco-modal.component';
// import { CuentaContableAsientoModalComponent } from './cuenta-contable-asiento-modal/cuenta-contable-asiento-modal.component';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    PipesModule,
    ReactiveFormsModule,
    FormsModule,
    ControlsModule,
    CustomFormModule,
    TextMaskModule,
  ],
  declarations: [
    // ProductoModalComponent,
    // ServicioModalComponent,
    // ProveedorModalComponent,
    // BlockModalComponent,
    // ClienteModalComponent,
    // ClienteProformaModalComponent,
    // ProductoPrecioModalComponent,
    // VentaModalComponent,
    // VentaFilterModalComponent,
    // CompraModalComponent,
    // CompraFilterModalComponent,
    // VentaListModalComponent,
    // RetencionModalComponent,
    // RetencionCompraModalComponent,
    // CompraListModalComponent,
    // PermisoModalComponent,
    // ImageModalComponent,
    // AperturaCajaModalComponent,
    // CierreCajaModalComponent,
    // PrecioAdicionalModalComponent,
    // ReposicionCajaModalComponent,
    // UsuarioModalComponent,
    // CajaModalComponent,
    // ReporteModalComponent,
    // FacturaModalComponent,
    // ProformaModalComponent,
    // GuiaremisionModalComponent,
    // AjusteInventarioModalComponent,
    // ReenviarCorreoComponent,
    // TransferenciasModalComponent,
    // TransferenciasListModalComponent,
    // NotacreditoModalComponent,
    // NotacreditoCompraModalComponent,
    // NotadebitoModalComponent,
    // ConfirmacionAnulacionModalComponent,
    // EditarPrecioModalComponent,
    // GastoModalComponent,
    // PreciosModalComponent,
    // PlanAcumulativoModalComponent,
    // EmitirRetencionCompraModalComponent,
    // EmitirGuiaremisionVentaModalComponent,
    // RetencionRentaModalComponent,
    // LoteModalComponent,
  //TransportistaModalComponent
  // CompraNotaModalComponent],
  // VentaNotaModalComponent
// OrdenCompraModalComponent
    // OrdenCompraAddModalComponent
  // PlanCuentasAddModalComponent,
    // PlanCuentasEditModalComponent,
    // OrdenCompraAddModalComponent,
    //PeriodoAddModalComponent
  // SalaMesaModalComponent
// FacturarPedidoModalComponent
// AsientoContableModalComponent
// AsientoContableEditModalComponent
// NivelHotelEditModalComponent
// TipoHabitacionHotelEditModalComponent
// HabitacionAddModalComponent

// HabitacionEditModalComponent

// PedidosSinSalaComponent
// CuentaContableModalComponent
// IceModalComponent
 // LectorBarraModalComponent
//HistorialPagoModalComponent
// ActivoFijoModalComponent
// CuentaContableAsientoModalComponent
// CuentaContableBancoModalComponent
// CuentaBancariaModalComponent
// MovimientoBancarioModalComponent
// ConciliacionModalComponent
// PrecioEditModalComponent

],
  entryComponents: [
    // ClienteModalComponent,
    // ClienteProformaModalComponent,
    // ProductoPrecioModalComponent,
    // ProveedorModalComponent,
    // ProductoModalComponent,
    // ServicioModalComponent,
    // UsuarioModalComponent,
    // CajaModalComponent,
    // ReporteModalComponent,
    // VentaModalComponent,
    // VentaFilterModalComponent,
    // CompraModalComponent,
    // CompraFilterModalComponent,
    // VentaListModalComponent,
    // RetencionModalComponent,
    // RetencionCompraModalComponent,
    // CompraListModalComponent,
    // PermisoModalComponent,
    // ImageModalComponent,
    // AperturaCajaModalComponent,
    // CierreCajaModalComponent,
    // PrecioAdicionalModalComponent,
    // EditarPrecioModalComponent,
    // ReposicionCajaModalComponent,
    // FacturaModalComponent,
    // ProformaModalComponent,
    // GuiaremisionModalComponent,
    // LoteModalComponent,
    // AjusteInventarioModalComponent,
    // ReenviarCorreoComponent, 
    // TransferenciasModalComponent,
    // TransferenciasListModalComponent,
    // NotacreditoModalComponent,
    // NotacreditoCompraModalComponent,
    // NotadebitoModalComponent,
    // ConfirmacionAnulacionModalComponent,
    // GastoModalComponent,
    // PreciosModalComponent,
    // PlanAcumulativoModalComponent,
    // EmitirRetencionCompraModalComponent,
    // EmitirGuiaremisionVentaModalComponent,
    // RetencionRentaModalComponent,
  ],
  exports: [
    // ClienteModalComponent,
    // ClienteProformaModalComponent,
    // ProductoPrecioModalComponent,
    // ProveedorModalComponent,
    // ProductoModalComponent,
    // ServicioModalComponent,
    // UsuarioModalComponent,
    // CajaModalComponent,
    // ReporteModalComponent,
    // VentaModalComponent,
    // VentaFilterModalComponent,
    // CompraModalComponent,
    // CompraFilterModalComponent,
    // VentaListModalComponent,
    // RetencionModalComponent,
    // RetencionCompraModalComponent,
    // PermisoModalComponent,
    // ImageModalComponent,
    // AperturaCajaModalComponent,
    // CierreCajaModalComponent,
    // PrecioAdicionalModalComponent,
    // EditarPrecioModalComponent,
    // ReposicionCajaModalComponent,
    // FacturaModalComponent,
    // ProformaModalComponent,
    // GuiaremisionModalComponent,
    // LoteModalComponent,
    // AjusteInventarioModalComponent,
    // ReenviarCorreoComponent, 
    // TransferenciasModalComponent,
    // TransferenciasListModalComponent,
    // NotacreditoModalComponent,
    // NotacreditoCompraModalComponent,
    // NotadebitoModalComponent,
    // ConfirmacionAnulacionModalComponent,
    // GastoModalComponent,
    // PreciosModalComponent,
    // PlanAcumulativoModalComponent,
    // EmitirRetencionCompraModalComponent,
    // EmitirGuiaremisionVentaModalComponent,
    // RetencionRentaModalComponent,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ],
})
export class ModalsModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/modals.module.ts